import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  academicYearList: null,
  status: 'idle',
  error: null,
};

const academicYearListSlice = createSlice({
  name: 'academicYearList',
  initialState,
  reducers: {
    setAcademicYearList(state, action) {
      state.academicYearList = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearAcademicYearList(state) {
      state.academicYearList = null;
      state.status = 'idle';
      state.error = null;
    },
    setError(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});

export const { setAcademicYearList, clearAcademicYearList, setError } = academicYearListSlice.actions;

export default academicYearListSlice.reducer;